import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA]">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-[#FF5A1F]/20 border-t-[#FF5A1F]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="max-w-md rounded-md border border-gray-200 bg-white p-8 text-center">
          <h2 className="text-xl font-semibold text-gray-900">Доступ запрещён</h2>
          <p className="mt-2 text-sm text-gray-600">У вашей роли нет прав для этой страницы.</p>
        </div>
      </div>
    );
  }

  return children;
}
